import React, {
  useState,
  useMemo,
  useCallback,
  useRef,
  useEffect,
} from "react";
import "bootstrap/dist/css/bootstrap.css";
import axios from "axios";
import { Container } from "reactstrap";
import { getToken } from "../../Utils/Common";
import { getAllTemplates, getAllTemplatesCount } from "api/TemaplateApi";
import Table from "../Table";
import "bootstrap/dist/css/bootstrap.css";
import Tooltip from "react-bootstrap/Tooltip";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import { useDispatch, useSelector } from "react-redux";
import {
  setTemplateType,
  setTemplateId,
  setTemplateParameterId,
  setBackFromAllTemplates,
  setTemplateLoading,
  setBaseTemplateId,
  setISOffer
} from "ReduxStore/Slices/templateSlice";

const AllTemplates = (props) => {
  const [dataApi, setDataApi] = useState([]);
  const [total, setTotal] = useState(0);
  const [pageCount, setPageCount] = useState(0);
  const [pageIndex, setPageIndex] = useState(0);
  const searchText = useRef("");
  const dispatch = useDispatch();

  const { templateLoading } = useSelector((state) => state.templateSetter);
  const data = useMemo(() => dataApi, [dataApi]);
  const columns = useMemo(
    () => [
      {
        Header: "Name",
        accessor: "name",
      },
      {
        Header: "Description",
        accessor: "description",
      },
      {
        Header: "Type",
        accessor: "type",
      },
      {
        // width: 300,
        Header: "Actions",
        accessor: "name_2",
        Cell: ({ cell }) => (
          <div className="template_action">
            <OverlayTrigger
              delay={{ hide: 50, show: 50 }}
              placement="top"
              key="top"
              overlay={(props) => (
                <Tooltip id="tooltip-top" {...props}>
                  Edit Template
                </Tooltip>
              )}
            >
              <i
                className="fa fa-edit"
                style={{ color: "gray", fontSize: "20px" }}
                onClick={(e) => {
                  e.stopPropagation();
                  urlToEditTemplate({
                    id: cell.row.original.id,
                    type: cell.row.original.type,
                  });
                }}
              ></i>
            </OverlayTrigger>
            <OverlayTrigger
              delay={{ hide: 50, show: 50 }}
              placement="top"
              key="top"
              overlay={(props) => (
                <Tooltip id="tooltip-top" {...props}>
                  Delete Template
                </Tooltip>
              )}
            >
              <i
                className="fa fa-trash"
                onClick={(e) => {
                  e.stopPropagation();

                  deleteTemplate(e, cell.row.original.id, cell.row.index);
                }}
                style={{ color: "gray", fontSize: "20px" }}
              ></i>
            </OverlayTrigger>
          </div>
        ),
      },
    ],
    [dataApi]
  );
  useEffect(() => {
    dispatch(setTemplateLoading(true));
  }, []);

  const fetchData = useCallback(async ({ pageSize, pageIndex }) => {
    dispatch(setTemplateLoading(true));
    const startRow = pageSize * pageIndex;
    const endRow = startRow + pageSize;
    setPageIndex(pageIndex);

    searchText.current.value !== ""
      ? await getAllTemplatesCount(searchText.current.value)
        .then((data) => {
          setPageCount(Math.ceil(data.count / pageSize));
          setTotal(data.count);
        })
        .catch((e) => { })
      : await getAllTemplatesCount()
        .then((data) => {
          setPageCount(Math.ceil(data.userTemplateCount / pageSize));
          setTotal(data.userTemplateCount);
        })
        .catch((e) => { })

    searchText.current.value !== ""
      ? await getAllTemplates(pageSize, startRow, searchText.current.value)
        .then((data) => {
          setDataApi(data);
          dispatch(setTemplateLoading(false));
        })
        .catch((e) => { })
      : await getAllTemplates(pageSize, startRow)
        .then((data) => {
          setDataApi(data);
          dispatch(setTemplateLoading(false));
        })
        .catch((e) => { })
  }, []);

  const deleteTemplate = async (e, id, idx) => {
    if (window.confirm(`Are you sure you want to delete this template?`)) {
      const token = "Bearer " + getToken();
      const options = {
        headers: { Authorization: token },
      };
      var delConfig = {
        method: "delete",
        url: process.env.REACT_APP_API_BASE_URL + "personal/templates/" + id,
        headers: { Authorization: token },
      };
      await axios(delConfig)
        .then((res) => {
          let temp = [...dataApi];
          temp.splice(idx, 1);
          setDataApi(temp);

        })
        .catch((err) => {

        });
      getAllTemplatesCount()
        .then((data) => {
          setTotal(data.userTemplateCount);
        })
        .catch((e) => { })
    }
  };

  const urlToEditTemplate = (id) => {


    let template = data.filter(e => e.id == id.id)
    template = template[0]

    dispatch(setBaseTemplateId(id));
    dispatch(setTemplateId(id.id));
    dispatch(setTemplateType(id.type));
    dispatch(setBackFromAllTemplates(true));
    dispatch(setTemplateParameterId(id.id));
    dispatch(setISOffer(id.layoutType == 'offer' || template.category == "Offers" ? true : false))
    // sessionStorage.setItem("backFromAllTemplates", "true");
    // sessionStorage.setItem("t_id", id.id);
    // sessionStorage.setItem("template_type", id.type);
    // sessionStorage.setItem("editorType", id.type);
    // sessionStorage.setItem("param_id", id.id);
    props.history.push(`/admin/templates/info`);
  };

  return (
    <Container>
      <div className="page_heading">
        <h2>Template List</h2>

        <p className="sm d-flex align-items-center">
          You have {total} templates.
        </p>
      </div>
      <div></div>
      <div className="dataTableOuter">
        <div className="search_bar_wrap d-flex">
          {/* <label className="search_label mr-3">Search</label> */}
          <input
            className="form-control search-input"
            id="search_input"
            placeholder="Enter Name or Description "
            ref={searchText}
            style={{ maxWidth: "23%", marginLeft: "25px" }}
            onKeyDown={(e) => {
              if (e.keyCode === 13) {
                dispatch(setTemplateLoading(true));
                fetchData({
                  pageSize: 10,
                  pageIndex: 0,
                  searchText: searchText.current.value,
                })
                  .then(() => {
                    dispatch(setTemplateLoading(false));
                  })
                  .catch((e) => { })
              }
            }}
          />
          <button
            onClick={() => {
              dispatch(setTemplateLoading(true));
              fetchData({
                pageSize: 10,
                pageIndex: 0,
                searchText: searchText.current.value,
              })
                .then(() => {
                  dispatch(setTemplateLoading(false));
                })
                .catch((e) => { })
            }}
            className="lg_btn tertiary search_btn"
            style={{ height: "38px", margin: "0 0 1vh 1vh" }}
          >
            {templateLoading ? "Loading..." : "Search"}
          </button>
        </div>
        <div className="table-flter rdt_Pagination d-flex align-items-center">
          <span className="inline-label ml-auto">
            Page No. {pageIndex + 1} of {pageCount}
          </span>
        </div>
        {
          < Table
            columns={columns}
            data={data}
            rowClickFunction={urlToEditTemplate}
            table_type={"AllTemplate"}
            fetchData={fetchData}
            pageCount={pageCount}
            loading={templateLoading}
          ></Table>
        }
      </div>
    </Container >
  );
};

export default AllTemplates;
